// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active[data-v-14d984fe] {\n  background: #fff;\n  color: #37474F !important;\n}\n.specialNoteRow[data-v-14d984fe] {\n  height: 30px;\n}\n@media (max-width: 1500px) {\n.display-dot[data-v-14d984fe] {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
